import type { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import TextField from '@app/components/input/TextField';
import useValidationMessage from '@app/hooks/useValidationMessage';

import { AddressFormFields } from '../Address.constants';
import messages from '../Address.messages';

export const CompanyField: FC<{ namespace: string }> = ({ namespace }) => {
  const {
    control,
    formState: { errors },
    register,
  } = useFormContext();

  const { msg } = useValidationMessage(messages);

  const vatNumberValue = useWatch({
    control,
    name: `${namespace}.${AddressFormFields.VatNumber}`,
    defaultValue: '',
  });
  const isCompanyRequired = Boolean(vatNumberValue);

  return (
    <TextField
      {...register(`${namespace}.${AddressFormFields.Company}`, {
        required: {
          value: isCompanyRequired,
          message: msg({
            type: 'required',
            key: 'company',
          }),
        },
      })}
      data-testid={`${namespace}-company`}
      autoComplete="organization"
      maxLength={128}
      isValid={!errors[namespace]?.[AddressFormFields.Company]}
      formLabel={
        <>
          <FormattedMessage {...messages.company} />
          {!isCompanyRequired && (
            <>
              {' '}
              (<FormattedMessage {...messages.optional} />)
            </>
          )}
        </>
      }
    />
  );
};
